import LoadingSpinner from './LoadingSpinner';
export default LoadingSpinner;


// WEBPACK FOOTER //
// ./~/buildo-react-components/src/loading-spinner/index.js